import { FETCH_REVIEWS_PAGE } from 'features/reviews';
import { call, put, takeEvery } from 'redux-saga/effects';
import { createAction } from 'typesafe-actions';
import {
  selectProductId,
  selectReviewsTotalCount,
  selectReviewsTotalScore,
  selectVariantsRatingAvg,
  selectVariantsReviewsTotal,
} from './selectors';

/**
 * Cобытие должно срабатывать при приходе данных от shoppilot
 *
 * @see https://docs.google.com/document/d/1Y_vg_aaS7COYvoc4daxezKkWJUiH2Wn-hLAJ9D2ziac/edit#
 */
export const gaShoppilot = createAction('GA:shoppilot')<{
  elementType: 'product';
  elementBlock: 'reviews'; // блок, в котором расположен элемент

  productId: string; // артикул товара
  reviews: string; // количество отзывов
  avgRating: string; // рейтинг товара
  variantsReviewsTotal: string; // суммарное количество отзывов о всех вариантах товара
  variantsRatingAvg: string; // средний рейтинг среди всех вариантов товара
}>();

export function* putGaShoppilot() {
  yield put(
    gaShoppilot({
      elementType: 'product',
      elementBlock: 'reviews',
      productId: yield call(selectProductId),
      reviews: yield call(selectReviewsTotalCount),
      avgRating: yield call(selectReviewsTotalScore),
      variantsReviewsTotal: yield call(selectVariantsReviewsTotal),
      variantsRatingAvg: yield call(selectVariantsRatingAvg),
    }),
  );
}

export function* runShoppilotDetector() {
  yield takeEvery(FETCH_REVIEWS_PAGE.success, putGaShoppilot);
}
